import {
  TYPENAMEREGEX,
  TYPEEMAILREGEX,
  TYPENUMBERREGEX,
  TYPETEXTAREAREGEX,
  TYPEONLYLETTERSREGEX,
  TYPELETTERSNUMBERSREGEX,
  TYPEDECIMALREGEX,
  TYPELATLNGREGEX,
} from "./Regex";

export const validateField = (type, value, name) => {
  if (type === "text") {
    if (!TYPENAMEREGEX.test(value)) {
      return `El ${name} es inválido, solo se admiten letras, espacios y '-'`;
    }
  } else if (type === "email") {
    if (!TYPEEMAILREGEX.test(value)) {
      return `El ${name} es inválido`;
    }
  } else if (type === "number") {
    if (value == "0" || value === "") {
      return `El ${name} es inválido, no puede ser 0 ni estar vacio`;
    } else if (value && !TYPENUMBERREGEX.test(value)) {
      return `El ${name} es inválido, solo se permiten numeros`;
    }
  } else if (type === "textArea") {
    if (!TYPETEXTAREAREGEX.test(value)) {
      return `El texto no es valido, no se aceptan caracteres especiales ($%&'()*+-/:;<=>?@[]^_{|}~)`;
    }
  } else if (type === "letras") {
    if (!TYPEONLYLETTERSREGEX.test(value)) {
      return `El texto no es valido, solo se aceptan letras`;
    }
  } else if (type === "numerosLetras") {
    if (!TYPELETTERSNUMBERSREGEX.test(value)) {
      return `El texto no es valido, solo letras y numeros`;
    }
  } else if (type === "decimal") {
    if (!TYPEDECIMALREGEX.test(value)) {
      return `${name} no es valido`;
    }
  } else if (type === "numberWnull") {
    if (value && !TYPENUMBERREGEX.test(value)) {
      return `El ${name} es inválido, solo se permiten numeros`;
    }
  } else if (type === "latLng") {
    if (!TYPELATLNGREGEX.test(value)) {
      return `Coordenadas inválidas`;
    }
  }
};

export const validateOnSubmit = (type, value) => {
  if (type === "text") {
    if (!TYPENAMEREGEX.test(value)) {
      return true;
    }
  } else if (type === "email") {
    if (!TYPEEMAILREGEX.test(value)) {
      return true;
    }
  } else if (type === "number") {
    if (value === "0" || value === "") {
      return true;
    } else if (!TYPENUMBERREGEX.test(value)) {
      return true;
    }
  } else if (type === "textArea") {
    if (!TYPETEXTAREAREGEX.test(value)) {
      return true;
    }
  } else if (type === "letras") {
    if (!TYPEONLYLETTERSREGEX.test(value)) {
      return true;
    }
  } else if (type === "numerosLetras") {
    if (!TYPELETTERSNUMBERSREGEX.test(value)) {
      return true;
    }
  } else if (type === "decimal") {
    if (!TYPEDECIMALREGEX.test(value)) {
      return true;
    }
  } else if (type === "numberWnull") {
    if (!TYPENUMBERREGEX.test(value)) {
      return true;
    }
  } else if (type === "latLng") {
    if (!TYPELATLNGREGEX.test(value)) {
      return true;
    }
  }
};

/**
 * Valida si el valor es un número válido para una etapa.
 *
 * @param {string|number} value - El valor a validar.
 * @param {string} name - El nombre del campo que se está validando.
 * @param {boolean} isLimpieza - Indica si se permite un valor nulo o vacío.
//  * @param {number} maxNumTotalEtapaSC - El número máximo de etapas permitido.
//  * @param {number} maxNumPozoEtapaSC - El número máximo de pozos permitido.
 * @param {number} numPozoEtapaSC - El número actual de pozos de la etapa.
 * @returns {string|boolean} Un string con un mensaje de error si el valor es inválido, o true si es válido.
 */
export const validateEtapasNumber = ({
  value,
  name,
  isLimpieza,
  // maxNumTotalEtapaSC,
  // maxNumPozoEtapaSC,
  numPozoEtapaSC,
  etapasPlanificacionList,
}) => {
  console.log("value", value);
  console.log("numPozoEtapaSC", numPozoEtapaSC);
  console.log("etapasPlanificacionList", etapasPlanificacionList);

  switch (!isLimpieza) {
    case value == 0 || value === "":
      return `El ${name} es inválido, no puede ser 0 ni estar vacío`;
    case !TYPENUMBERREGEX.test(value):
      return `El ${name} es inválido, solo se permiten números`;
    // case name === "Nro. Etapa pozo" && value > maxNumPozoEtapaSC:
    //   return `El ${name} es inválido, no puede ser mayor a ${maxNumPozoEtapaSC} `;
    case name === "Nro. Etapa pozo" && numPozoEtapaSC?.includes(value):
      return `El ${name} es inválido, ya existe una etapa con ese número`;
    // case name === "Nro. Etapa Total" && value > maxNumTotalEtapaSC:
    //   return `El ${name} es inválido, no puede ser mayor a ${maxNumTotalEtapaSC} `;
    case name === "Nro. Etapa Total" &&
      etapasPlanificacionList?.includes(value):
      return `El ${name} es inválido, ya existe una etapa con ese número`;
    default:
      return "";
  }
};
